import { Reducer } from "redux";
import { SocialSecurityAction, SocialSecurityState } from "./types";

const initialState: SocialSecurityState = {
  status: "init"
};

const reducer: Reducer<SocialSecurityState, SocialSecurityAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case "socialSecurity/FETCH_INFO":
      if (state.status === "loaded") {
        return {
          ...state
          // No update this information
          // status: "updating"
        };
      } else {
        return {
          status: "loading"
        };
      }
    case "socialSecurity/FETCH_INFO_SUCCEEDED":
      return {
        status: "loaded",
        payload: action.socialSecurityInfo
      };
    case "socialSecurity/FETCH_INFO_FAILED":
      return {
        status: "error",
        error: action.error
      };
    case "socialSecurity/CLEAR_STORE":
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default reducer;
